"use client";
import React from "react";
import Link from "next/link";

type Btn = {
  title?: string;
  url?: string;
  variant?: string;
  target?: string;
  content?: React.ReactNode;
};

interface Props {
  buttons?: Btn[];
  localizedPath?: (path: string) => string;
  containerClass?: string;
  btnClassPrimary?: string;
  btnClassSecondary?: string;
}

const ButtonGroup = ({
  buttons = [],
  localizedPath,
  containerClass = "",
  btnClassPrimary = "btn-primary btn-sm flex-grow md:flex-grow-0 justify-center md:justify-start",
  btnClassSecondary = "btn-secondary btn-sm flex-grow md:flex-grow-0 justify-center md:justify-start",
}: Props) => {
  return (
    <div className={containerClass}>
      {buttons.map((btn, i) => {
        const isExternal = btn?.target === "_blank";
        const href = btn?.url
          ? isExternal
            ? btn.url
            : localizedPath
            ? localizedPath(btn.url as string)
            : btn.url
          : "#";
        const target = btn?.target || (isExternal ? "_blank" : undefined);
        const rel = target === "_blank" ? "noopener noreferrer" : undefined;
        const className = btn?.variant === "primary" ? btnClassPrimary : btnClassSecondary;

        return (
          <Link
            key={i}
            href={href}
            title={typeof btn.title === 'string' ? btn.title : undefined}
            className={className}
            target={target}
            rel={rel}
          >
            {btn.content ?? btn.title}
          </Link>
        );
      })}
    </div>
  );
};

export default ButtonGroup;
